import { HTMLAttributes } from 'react'

import styles from './styles.module.scss'

interface WatchCountProps extends HTMLAttributes<HTMLSpanElement> {
  countValue?: number;
}

export default function WatchCount (props: WatchCountProps) {
  const { countValue, ...rest } = props

  const formattedCount =
    typeof countValue === 'number' ? countValue.toLocaleString('ru-RU') : ''

  return (
    <div className={styles.root} {...rest}>
      <img src="/icons/eye.svg" alt="" loading="lazy" fetchPriority="low" />
      {formattedCount}
    </div>
  )
}
